/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { getSection, initColumnNameToSections } from '../../helper';
import {
  Column,
  CreateConsigneeGoodsSpecificationAction,
  CreateConsigneeGoodsSpecificationActionTypes,
  FileData,
  Sections,
} from './types';
import { ConsigneeProfile } from '../../../consignee-profiles/redux/reducer';

interface CreateConsigneeGoodsSpecState {
  groupedFileUrl: string | null;
  sections: Sections;
  files: FileData;
  columns: Column[];
  consigneeProfile: ConsigneeProfile | null;
  loading: boolean;
  error: Error | null;
  isSuccess: boolean;
}

export const createConsigneeGoodsSpecificationInitialState: CreateConsigneeGoodsSpecState =
  {
    groupedFileUrl: null,
    sections: [],
    columns: [],
    files: {},
    consigneeProfile: null,
    loading: false,
    error: null,
    isSuccess: false,
  };

export function createConsigneeGoodsSpecification(
  state: CreateConsigneeGoodsSpecState = createConsigneeGoodsSpecificationInitialState,
  action: CreateConsigneeGoodsSpecificationAction,
): CreateConsigneeGoodsSpecState {
  switch (action.type) {
    case CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_REQUEST:
      return update(state, {
        loading: { $set: true },
        error: { $set: null },
      });

    case CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_SUCCESS:
      return update(state, {
        loading: { $set: false },
        groupedFileUrl: { $set: action.payload.exportFile.url },
      });

    case CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_ERROR:
      return update(state, {
        loading: { $set: false },
        error: { $set: action.error },
      });

    case CreateConsigneeGoodsSpecificationActionTypes.SET_CREATE_CONSIGNEE_GOOD_FIELD:
      const { field, value, childField } = action;

      if (childField) {
        return update(state, {
          [field]: {
            [childField]: { $set: value },
          },
        });
      }

      return update(state, {
        [field]: { $set: value },
      });

    case CreateConsigneeGoodsSpecificationActionTypes.ADD_COLUMN_TO_TABLE:
      const { sections } = state;
      const { column } = action;
      const { fileName, position } = column;

      const { section, sectionIndex } = getSection(fileName, sections);

      section?.values.splice(position as number, 1);

      return update(state, {
        columns: { $push: [column as Column] },
        sections: { $splice: [[sectionIndex, 1, section]] },
      });

    case CreateConsigneeGoodsSpecificationActionTypes.ADD_COLUMN_TO_SIDEBAR:
      const updatedSections = initColumnNameToSections(
        action.column as Column,
        state.sections,
      );

      const columnIndex = state.columns.findIndex(
        (col) => col.id === action.column.id,
      );

      if (columnIndex !== -1) {
        return update(state, {
          sections: { $set: updatedSections },
          columns: { $splice: [[columnIndex, 1]] },
        });
      }

      return state;

    case CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_RESET:
      return createConsigneeGoodsSpecificationInitialState;

    default:
      return state;
  }
}
